export function creditCardDetect(number) {
  return new Promise((resolve, reject) => {
    // Visa, Amex, Discover, MasterCard

    // Create matched object
    if (number.match(/^(?:4[0-9]{12}(?:[0-9]{3})?)$/)) {
      resolve('visa')
    } else if (number.match(/^3[47][0-9]{13}$/)) {
      resolve('amex')
    } else if (number.match(/^(?:6011\s?-?\d{12}|64[4-9]\s?-?\d{13}|65\s?-?\d{14})(?:[\s-]?)$/)) {
      resolve('discover')
    } else if (number.match(/^5[1-5][0-9]{14}$/)) {
      resolve('master')
    } else {
      resolve('')
    }
  })
}
export async function cardResult() {
  const cards = $('#payment-type-select').find('.payment-type-card')
  const cardNumber = $('#creditCardNumber').val()
  const result = await creditCardDetect(cardNumber)

  $.each(cards, (i, card) => {
    if ($(card).attr('data-credit-card-name') == result) {
      $(card).addClass('active')
    } else {
      $(card).removeClass('active')
    }
  })
}
// export async function cardResult() {
//   const cards = $('#payment-type-select').find('.payment-type-card')
//   try {
//     const cardNumber = $('#creditCardNumber').val()
//     const result = await creditCardDetect(cardNumber)

//     $.each(cards, (i, card) => {
//       if ($(card).attr('data-credit-card-name') == result) {
//         // $(card).fadeIn()
//         $(card)
//           // .removeClass('payment-icon--unknown')
//           .addClass('active')
//       } else {
//         // $(card).fadeOut()
//         $(card)
//           // .addClass('payment-icon--unknown')
//           .removeClass('active')
//       }
//     })
//   } catch (err) {
//     // $(cards).removeClass('active')
//   }
// }

export function triggerCardResult() {
  $('#creditCardNumber').on({
    focus: () => {
      cardResult()
    },
    blur: () => {
      cardResult()
    },
    keyup: () => {
      cardResult()
    },
    keydown: () => {
      cardResult()
    }
  })
}

window.cardResult = cardResult
